import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Form, Radio, Row, Select } from 'tdesign-react';
import Text from '@/components/Text';
import Tip from '@/components/Tip';
import {
  QUICK_DEPLOY_STEPS,
  setQuickDeployClusterInfo,
  setQuickDeployStep,
} from '@/slices/clusterSlice';
import { fetchK8sOptions } from '@/slices/resourceSlice';
import { isVoid, toTsOptions } from '@/utils/common';
import CreateNew from './CreateNew';

const { FormItem } = Form;

function MaintainK8sStep({
  setQuickDeployStep,
  fetchK8sOptions,
  k8sOptions,
  envOptions,
  setQuickDeployClusterInfo,
}) {
  const [form] = Form.useForm();
  const opsEnvId = Form.useWatch('opsEnvId', form);
  const selectK8sCluster = Form.useWatch('selectK8sCluster', form);

  useEffect(() => {
    fetchK8sOptions();
  }, [fetchK8sOptions]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      const cache = { ...fields };
      setQuickDeployClusterInfo(cache);
      setQuickDeployStep(QUICK_DEPLOY_STEPS.CHOICE_CLUSTER);
    }
  };

  const handleNext = (data) => {
    const cache = { ...data, opsEnvId, contexts: data.namespace, k8sId: data.id };
    console.log(cache);
    setQuickDeployClusterInfo(cache);
    setQuickDeployStep(QUICK_DEPLOY_STEPS.CHOICE_CLUSTER);
  };

  const resetFormItems = () => {
    form.reset({
      fields: ['kubeName', 'configClusterName', 'namespace', 'desc'],
    });
  };

  const envChange = async () => {
    resetFormItems();
  };

  const k8sChange = (_, { selectedOptions }) => {
    const values = selectedOptions[0];
    form.setFieldsValue({
      kubeName: values.kubeName,
      configClusterName: values.configClusterName,
      contexts: values.namespace,
      desc: values.desc,
    });
  };

  return (
    <Root>
      <Form
        form={form}
        labelWidth={160}
        initialData={{ selectK8sCluster: 'choiceExists' }}
        onSubmit={handleSubmit}
      >
        <FormItem
          name='opsEnvId'
          style={{ width: '80%' }}
          label={
            <Tip content='环境表示一个独立的网络区域，一般在管理员部署阶段初始化，如果没有找到的你需要的环境，请联系管理员创建'>
              选择环境
            </Tip>
          }
          rules={[{ required: true }]}
        >
          <Select options={toTsOptions(envOptions)} onChange={envChange} />
        </FormItem>
        {!isVoid(opsEnvId) && (
          <>
            <FormItem style={{ width: '80%' }} name='selectK8sCluster' label='选择'>
              <Radio.Group>
                <Radio value='choiceExists'>现有K8s</Radio>
                <Radio value='createNew'>新建K8s</Radio>
              </Radio.Group>
            </FormItem>
            {selectK8sCluster === 'choiceExists' ? (
              <>
                <FormContainer>
                  <FormItem label='k8s集群' name='k8sId' rules={[{ required: true }]}>
                    <Select
                      options={toTsOptions(k8sOptions.filter((item) => item.envId === opsEnvId))}
                      onChange={k8sChange}
                    />
                  </FormItem>
                  <FormItem label='K8s名称' name='kubeName'>
                    <Text />
                  </FormItem>
                  <FormItem label='Cluster-name' name='configClusterName'>
                    <Text />
                  </FormItem>
                  <FormItem label='Operator Namespace' name='contexts'>
                    <Text />
                  </FormItem>
                  <FormItem label='备注' name='desc'>
                    <Text />
                  </FormItem>
                </FormContainer>
                <Row justify='end' style={{ marginTop: 20 }}>
                  <Button onClick={() => form.submit()}>下一步</Button>
                </Row>
              </>
            ) : (
              <CreateNew envId={opsEnvId} handleNext={handleNext} />
            )}
          </>
        )}
      </Form>
    </Root>
  );
}

export default connect(
  (state) => ({
    envOptions: state.resource.envOptions,
    k8sOptions: state.resource.k8sOptions,
  }),
  {
    setQuickDeployStep,
    fetchK8sOptions,
    setQuickDeployClusterInfo,
  },
)(MaintainK8sStep);

const Root = styled.div`
  margin-top: 20px;
`;

const FormContainer = styled.div`
  width: 80%;
`;
